import { Controller } from "@hotwired/stimulus"

// Nothing animates while it is scrolled out of the viewport. The host and
// everything inside it get .is-offscreen, which application.css turns into
// animation-play-state: paused. Paused rather than removed, so an animation
// picks up mid-cycle when the host scrolls back instead of restarting.
//
// Every frame an animation produces keeps the CPU, GPU and display awake
// (Apple, Energy Efficiency Guide: "Eliminate drawing when your app or its
// content is not visible"). A budgeting screen left open for an hour with a
// looping mascot below the fold was paying for that mascot the whole time.
//
// Usage: <div data-controller="in-view-animation">...looping animations...</div>
//
// display:none hosts (a carousel panel that is not showing) never run their
// animations in the first place; this covers the on-page, below-the-fold case.
const OFFSCREEN_CLASS = "is-offscreen"

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.element.classList.toggle(OFFSCREEN_CLASS, !entry.isIntersecting)
      })
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    // Turbo snapshots the DOM as it stands; a paused host baked into the
    // snapshot would show frozen until the observer reconnects.
    this.element.classList.remove(OFFSCREEN_CLASS)
  }
}
